module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/265.7590cd5b.png";